import axios from "axios";
const BASE = "/api";
const api  = axios.create({ baseURL: BASE });
export const getStats           = ()  => api.get("/stats");
export const getAlerts          = ()  => api.get("/alerts");
export const getProphetForecast = (h) => api.post("/forecast/prophet", { hours: h });
export const getPriceForecast   = (h) => api.post("/forecast/price",   { hours: h });
export const getAnomalies       = (n) => api.post("/anomalies",        { n_records: n });
export const getHistorical      = (h) => api.post("/historical",       { hours: h });
export const get3DSimData       = (h) => api.post("/simulation/3d",    { hours: h });
export const getRevenue         = (kw)=> api.post("/predict/revenue",  { power_kw: kw });
